export default __webpack_public_path__ + "static/media/SlashStgWeakIcon.89cce6c3.png";